import { useCallback, useEffect, useState } from 'react';

const readSessionValue = (key, initialValue) => {
  try {
    const stored = window.sessionStorage.getItem(key);
    return stored === null ? initialValue : JSON.parse(stored);
  } catch {
    return initialValue;
  }
};

// Keep an admin's list/navigation context while this browser tab is open.
export const useAdminSessionState = (key, initialValue) => {
  const [entry, setEntry] = useState(() => ({ key, value: readSessionValue(key, initialValue) }));
  const value = entry.key === key ? entry.value : readSessionValue(key, initialValue);
  const setValue = useCallback(next => {
    setEntry(previous => {
      const current = previous.key === key ? previous.value : readSessionValue(key, initialValue);
      return { key, value: typeof next === 'function' ? next(current) : next };
    });
  }, [key, initialValue]);

  useEffect(() => {
    // Switching accounts or reference lists must not copy the previous search.
    if (entry.key !== key) {
      setEntry({ key, value });
      return;
    }
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      // Storage can be unavailable in private browsing; in-memory state still works.
    }
  }, [entry.key, key, value]);

  return [value, setValue];
};
